import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CheckBoxListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
